import React from "react";
import { useParams } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import Header from "../../Header/header";
import Whatsapp from "../../Whatsapp/Whatsapp";
import locationPagesData from "./locationPagesData";
import "./LocationTreatmentPage.css";

const LocationTreatmentPage = () => {
  const { slug } = useParams();
  const data = locationPagesData[slug];

  if (!data) {
    return (
      <div className="asthmacontent">
        <Header />
        <Whatsapp />
        <div style={{ padding: "160px 50px", textAlign: "center" }}>
          <h2>Page not found</h2>
          <p>The treatment page you are looking for does not exist.</p>
          <a href="/">Return to Home</a>
        </div>
      </div>
    );
  }

  return (
    <div className="asthmacontent">
      <Header />
      <Whatsapp />
      <div className="asthmamain">
        <div className={data.heroClass}>
          <div className="asthmainner">
            <div className="heroservice">
              Service <RiArrowRightSLine /> {data.heroServiceLabel}
            </div>
            <div className="heroheadline">
              <h1 style={{ marginBottom: "20px", fontWeight: "bold" }}>
                {data.h1}
              </h1>
              <p style={{ fontFamily: "inherit" }}>{data.heroParagraph}</p>
            </div>
            <a href="/appoint">
              <button className="asthmabtn">Book Now</button>
            </a>
          </div>
        </div>

        <div className="asthmamid">
          <div className="asthmapra">
            {/* Intro section */}
            <div>
              <h2 style={{ fontSize: "30px", fontWeight: "bold" }}>
                {data.h2}
              </h2>
              {data.intro.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>

            {/* Dynamic sections */}
            {data.sections.map((section, i) => (
              <div key={i}>
                <h3 style={{ fontSize: "23px" }}>{section.h3}</h3>
                {section.content && <p>{section.content}</p>}
                {section.list && (
                  <ul>
                    {section.list.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.afterList && <p>{section.afterList}</p>}
              </div>
            ))}
          </div>

          {/* Reviews sidebar */}
          <div className="asthmareview">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#85553D",
                fontFamily: "inherit",
              }}
            >
              What Our Patients Say
            </p>
            {data.reviews.map((review, i) => (
              <div key={i} className={`card${(i % 3) + 1}`}>
                <p>{review.text}</p>
                <p>{review.author}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationTreatmentPage;
